<template>
<v-row class="im-result regular" no-gutters align="center">
    <v-col cols="2" sm="1" md="1" class="px-1">
        <div>
            {{item.id}}
        </div>
    </v-col>
    <v-col cols="10" sm="4" md="3" class="px-1">
        <div>
            <span v-if="$vuetify.breakpoint.smAndDown">Service: </span>
            {{item.service}}
        </div>
    </v-col>
    <v-col cols="5" sm="7" md="3" class="px-1">
        <div>
            {{item.slug}}
        </div>
    </v-col>
    <v-col cols="12" md="5" class="px-1">
        <v-row align="center" no-gutters>
            <v-chip v-for="(id,index) in item.listeners" :small="$vuetify.breakpoint.smAndDown" :class="{'detail': $vuetify.breakpoint.smAndDown, 'ma-1':true}" :key="index">
                {{filteredListeners(id)}}
            </v-chip>
        </v-row>
    </v-col>
</v-row>
</template>

<script>
export default {
    props: {
        item: Object,
        listeners: Array
    },
    methods: {
        emitClick() {
            this.$emit("click");
        },
        filteredListeners: function (id) {
            let listeners = this.listeners.filter((item) => {
                if(item.value === id) return item;
            });
            return listeners.length > 0 ? listeners[0].text : null;
        }
    },
};
</script>
